export default __webpack_public_path__ + "static/media/PipeLineResponsiveSmall.3ae6da5c.png";